module.exports = __webpack_public_path__ + "next-arrow-9028f6cb793ee7396fc1d4f8430affe0.svg";